import { SET_ACTIVE_ROUTE } from "../constants";
import { qualifySelector } from "../utils";

const initialState = {
  pageName: null,
  accountName: null,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_ROUTE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const name = "routing";
export default { [name]: reducer };

export const getRouterParams = qualifySelector(name, (state) => state);
export const getPageName = qualifySelector(name, (state) => state.pageName);
